// define([
// 	'jquery',
// 	'base/MbiHelper',
// 	'project/MbiConfig',
// 	'base/MbiMediaQuery',
// 	'root/Assets/Templates/Html/Contact/Js/Modules/MbiGoogleMaps'
	
// ], function(
// 	$,
// 	_,
// 	mbiConfig, 
// 	mbiMq, 
// 	mbiGoogleMaps
// )
// {
// 	'use strict';
	// mbiConfig.urls = {'assets' : ASSETS_URL};
	// // ------------------------------------------------------------------------
	// // GOOGLE MAPS SETUP
	// // ------------------------------------------------------------------------

	// var initGoogleMaps;

	// 	initGoogleMaps = function(canvasID, longitude, latitude) {
	// 		var locations;
	// 		var lat = latitude;
	// 		var lng = longitude;

	// 		var styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
	// 		var markerClickedHandler = function(marker, address) {

	// 		};

	// 		//change to correct marker
	// 		var customMarkerURL = mbiConfig.urls.assets + "Svg/pin.svg";

	// 		var mapcenter = new google.maps.LatLng(lat, lng);

	// 		// _.log('lap-' in mbiMq.mqArea);

	// 		var isDraggable         = true;
	// 		var isNavigationControl = true;
	// 		var isScaleControl      = true;
	// 		var isPanControl        = true;
	// 		var isZoomControl       = false;

	// 		if ('landscape-' in mbiMq.mqArea) {
	// 			isDraggable         = false;
	// 			isNavigationControl = false;
	// 			isScaleControl      = false;
	// 			isPanControl        = false;
	// 			isZoomControl       = false;
	// 		}

	// 		var args = {

	// 			center: {
	// 				latitude: lat,
	// 				langtitude: lng
	// 			},
	// 			mapOptions: {

	// 				zoom: 12,
	// 				center: mapcenter,
	// 				scrollwheel: false,
	// 				mapTypeControl: false,
	// 				navigationControl: isNavigationControl,
	// 				scaleControl: isScaleControl,
	// 				panControl: isPanControl,
	// 				zoomControl: isZoomControl,
	// 				streetViewControl: false,
	// 				draggable: isDraggable,
	// 				mapTypeId: 'ROADMAP',
	// 				styles: styles

	// 			},
	// 			extraOptions: {

	// 				mapCanvasID: canvasID, 
	// 				// markerIconUrl: 'http://imac16/GartenrastAt' + customMarkerURL,
	// 				markerIconUrl: mbiConfig.homePath + customMarkerURL,
	// 				markerIconWidth: 14,
	// 				markerIconHeight: 21,
	// 				markerCurrentLocationIconUrl: mbiConfig.homePath + customMarkerURL,
	// 				markerCurrentLocationIconWidth: 14,
	// 				markerCurrentLocationIconHeight: 21,
	// 				markerPath: 'CIRCLE', // path can be google.maps.SymbolPath.{BACKWARD_CLOSED_ARROW/BACKWARD_OPEN_ARROW/CIRCLE/FORWARD_CLOSED_ARROW/FORWARD_OPEN_ARROW} or SVG path notation
	// 				showAll: false,
	// 				maxZoomIn: 16,
	// 				maxZoomOut: 16,
					
	// 				markerClickCallback: markerClickedHandler

	// 			}

	// 		};

	// 		// console.log(mbiConfig);

	// 		mbiGoogleMaps.init(args);

	// 		//var marker = mbiGoogleMaps.createGoogleMapMarker(customMarkerURL, 46.8110402,15.5484358);
	// 		var marker = mbiGoogleMaps.createGoogleMapMarker(customMarkerURL, latitude, longitude);

			

	// 	}
	// 	if(_.exists('.googlemap')) {
	// 		var $mapcanvas = $('.googlemap .mapCanvas'),
	// 			id = $mapcanvas.attr('id'),
	// 			longitude = $mapcanvas.attr('data-longitude'),
	// 			latitude = $mapcanvas.attr('data-latitude');
	// 		initGoogleMaps(id, longitude, latitude);
	// 	}


// });
define("root/Assets/Templates/Html/Contact/Js/Contact", function(){});

